import { legacyPlugins } from "/usr/src/app/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.153.0_@rsbuild+core@2.2.14_@rspack+core@2.2.9_@s_5d2888198e5abc6aa3119b207950e1d4/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}